import { format } from 'date-fns';
import { Photo } from './interfaces';

type PhotoGroup = {
  date: Date;
  photos: Photo[];
};

export const groupByDate = (photos: Photo[]) => {
  return photos.reduce((groups: Record<string, PhotoGroup>, photo) => {
    const date = format(photo.date, 'dd-MM-yy');

    if (!groups[date]) {
      groups[date] = {
        date: photo.date,
        photos: [],
      };
    }

    groups[date].photos.push(photo);

    return groups;
  }, {});
};
